export interface NavItem {
    id: string
    label: string
    wide?: boolean
}

export interface PageLink {
    href: string
    label: string
}

export const NAV_ITEMS: Array<NavItem> = [
    { id: 'nutzen', label: 'Nutzen' },
    { id: 'leistungen', label: 'Leistungen' },
    { id: 'einsatzbereiche', label: 'Einsatz' },
    { id: 'ablauf', label: 'Ablauf' },
    { id: 'team', label: 'Team', wide: true },
    { id: 'faq', label: 'FAQ' }
]

export const FOOTER_SERVICE_LINKS: Array<PageLink> = [
    { href: '/#nutzen', label: 'Projektnutzen' },
    { href: '/#leistungen', label: 'Leistungen' },
    { href: '/#technik', label: 'Messtechnik' },
    { href: '/#einsatzbereiche', label: 'Einsatzbereiche' },
    { href: '/#ablauf', label: 'Ablauf' }
]

export const FOOTER_COMPANY_LINKS: Array<PageLink> = [
    { href: '/#referenzen', label: 'Referenzen' },
    { href: '/#team', label: 'Team' },
    { href: '/#faq', label: 'Häufige Fragen' },
    { href: '/#kontakt', label: 'Kontakt' }
]

export const LEGAL_LINKS: Array<PageLink> = [
    { href: '/impressum', label: 'Impressum' },
    { href: '/datenschutz', label: 'Datenschutz' },
    { href: '/agb', label: 'AGB' }
]
